<template>
  <div>
    <div class="container navigation">
      <div class="custom-headline headline" v-text="$ml.get('title')"></div>
      <div class="logo">
        <!--<img alt="logo" class="logourl" />-->
      </div>
      <router-link
        :to="{ name: 'home' }"
        tag="div"
        class="navigation-link push"
        v-text="$ml.get('strecken')"
        exact
      ></router-link>
      <router-link
        :to="{ name: 'highscores' }"
        tag="div"
        class="navigation-link right"
        v-text="$ml.get('highscore')"
        exact
      ></router-link>
      <LangChooser randval="1" />
      <div v-if="isLoggedIn" class="navigation-link logout-button" @click="showLogout = true">
        <ExitIcon title="logout" />
      </div>
    </div>
    <LogoutDialog :show="showLogout" @close="showLogout = false" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ExitIcon from "vue-material-design-icons/ExitRun";
import LogoutDialog from "../components/LogoutDialog";
import LangChooser from "../components/LangChooser";
// import { MLBuilder } from "vue-multilanguage";

export default {
  name: "Nav",
  components: { ExitIcon, LogoutDialog, LangChooser },
  data() {
    return {
      showLogout: false,
    };
  },
  computed: {
    ...mapGetters("authentication", ["isLoggedIn", "name"]),
  },
};
</script>

<style scoped>
.flag {
  height: 1rem;
  cursor: pointer;
  padding-right: 5px;
}

.navigation {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: linear-gradient(to right, #0a345f, #0178b7);
  height: 80px;
  position: fixed;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  z-index: 9950;
}

.navigation-link {
  font-size: 1rem;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 29px;
  align-self: flex-start;
}

.router-link-exact-active {
  border-bottom: 2px solid #00a7ff;
}

.navigation-link:hover {
  cursor: pointer;
  border-bottom: 2px solid white;
}

.logout-button {
  align-self: flex-start;
  color: rgba(255, 255, 255, 0.6);
}

.logout-button:hover {
  cursor: pointer;
  color: white;
}
.navigation-link.logout-button {
  margin-left: 10px;
}

.logout-overlay {
  position: absolute;
}

@media (min-width: 768px) {
  .headline {
    /* font-size: 2.5rem; */
    margin-left: 10px;
    font-size: 1.8rem;
    align-self: center;
  }
  .headline::after {
    /* content: "Rutschenkonfigurator";
    margin-left: 10px;
    font-size: 1.8rem;
    align-self: center; */
  }
  .push {
    margin-left: auto;
  }
}

@media (max-width: 768px) {
  .navigation {
    justify-content: space-between;
  }

  .headline {
    display: none;
  }

  .navigation-link.right {
    margin-left: auto;
  }

  .navigation-link {
    margin-left: 4px;
    margin-right: 4px;
  }
}

.logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  background-image: url("../assets/logo.svg");
  background-size: cover;
  width: 80px;
  background-size: cover;
  background-repeat: no-repeat;
}

.logo img {
  height: 100%;
  width: 100%;
}
</style>
